import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { CompanyChargesDetails, CompanyDailyBillingItems } from 'src/app/types';
import { sortByAlpha } from 'src/app/utilities/commonSorters';
import { StatementService } from '../statement.service';

export interface DriverCharges {
  driverName: string;
  workDayTotal: number;
  everyDayTotal: number;
  everyDayCharges: CompanyDailyBillingItems[];
  workDayCharges: CompanyDailyBillingItems[];
}

@Component({
  selector: 'lohi-company-charges',
  templateUrl: './company-charges.component.html',
  styles: [],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CompanyChargesComponent implements OnInit {
  public charges$: Observable<CompanyChargesDetails>;
  public driverCharges$: Observable<DriverCharges[]>;

  constructor(private statementService: StatementService) {}

  public ngOnInit(): void {
    this.charges$ = this.statementService.companyCharges$;
    this.driverCharges$ = this.charges$.pipe(map(groupByDriverId));
  }
}

function groupByDriverId(charges: CompanyChargesDetails): DriverCharges[] {
  if (!charges?.dailyBillingItems) {
    return [];
  }

  const driverGroup: Record<string, DriverCharges> = {};
  charges.dailyBillingItems.forEach((item) => {
    if (!driverGroup[item.driverId]) {
      driverGroup[item.driverId] = {
        driverName: item.driverName,
        workDayTotal: 0,
        everyDayTotal: 0,
        everyDayCharges: [],
        workDayCharges: [],
      };
    }
    if (item.billingInterval === 'every_day') {
      driverGroup[item.driverId].everyDayTotal += item.costInPennies;
      driverGroup[item.driverId].everyDayCharges.push(item);
    } else if (item.billingInterval === 'work_day') {
      driverGroup[item.driverId].workDayTotal += item.costInPennies;
      driverGroup[item.driverId].workDayCharges.push(item);
    }
  });

  const response = Object.values(driverGroup);
  response.forEach((driver) => {
    driver.everyDayCharges.sort((a, b) => a.costInPennies - b.costInPennies);
    driver.workDayCharges.sort((a, b) => a.costInPennies - b.costInPennies);
  });

  response.sort(sortByAlpha(['driverName']));
  return response;
}
